import axios from "axios";
import {
  GET_ALL_PROFIT_LOSS_BALANCE,
} from "../../../config/config";
import { IAPIPayload } from "../../../interfaces/apiInterface";

export const getAllProfitLossBalanceList = (data: IAPIPayload) => {
  return axios.post(GET_ALL_PROFIT_LOSS_BALANCE, data);
};
